import './read-more';
import './click-outside';



// WEBPACK FOOTER //
// ./directives/index.js